import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { currentUser } from "@/lib/mockData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ProCtx = createContext(null);
const KEY = "ovamx:pro";

const readCache = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};
const writeCache = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch {} };

export function ProProvider({ children }) {
  const [status, setStatus] = useState(() => readCache() || { user_id: currentUser.id, is_pro: false, plan: "free", since: null });
  const [upgrading, setUpgrading] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/pro/status`, { params: { user_id: currentUser.id } });
      setStatus(data);
      writeCache(data);
    } catch { /* offline ok */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const upgrade = async (plan = "pro_monthly") => {
    setUpgrading(true);
    try {
      const { data } = await axios.post(`${API}/pro/upgrade`, { user_id: currentUser.id, plan });
      setStatus(data);
      writeCache(data);
      return data;
    } finally { setUpgrading(false); }
  };

  const cancel = async () => {
    const { data } = await axios.post(`${API}/pro/cancel`, null, { params: { user_id: currentUser.id } });
    setStatus(data);
    writeCache(data);
    return data;
  };

  return (
    <ProCtx.Provider value={{ ...status, upgrading, upgrade, cancel, refresh }}>
      {children}
    </ProCtx.Provider>
  );
}

export const usePro = () => useContext(ProCtx);
